<template>
  <b-container fluid class="my-5 overflow-hidden">
    <span ref="ImageYouCanFind"></span>
    <b-row class="can-find py-5">
      <div class="items-list">
        <h2 class="items-title">{{ $t('home.design.youCanFind.title') }}</h2>
        <ul :class="listClass">
          <li
            v-for="item in listYouCanFind"
            :key="item.id"
            class="position-relative w-100 can-find-item"
            @mouseover="updateContent($t(item.description), item.image_url)"
          >
            <component
              :is="!item.externalLink ? 'nuxt-link' : 'a'"
              v-if="item.url"
              :to="urlLink(item.url, item.translateUrl, item.landingUrl)"
              :href="urlLink(item.url, item.translateUrl, item.landingUrl)"
              :target="!item.externalLink ? '_self' : '_blank'"
              class="d-flex w-100"
            >
              <h3 class="item-text">{{ $t(item.name) }}</h3>
            </component>
          </li>
        </ul>
      </div>
      <div class="item-description">
        <h3 class="description">{{ description }}</h3>
      </div>
      <div class="image-container">
        <transition name="fade">
          <img ref="imageToChange" :src="image_url" :alt="description" />
        </transition>
      </div>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      description: '',
      image_url: ''
    };
  },
  computed: {
    listYouCanFind() {
      return this.$g('HOME_DESIGN_YOU_CAN_FIND');
    },
    listClass() {
      var classList = [
        'mt-xl-4',
        'mt-lg-2',
        'flex',
        'flex-column',
        'justify-content-end',
        'justify-content-xl-center',
        'align-items-baseline',
        'pl-0'
      ];

      return classList.join(' ');
    }
  },
  mounted() {
    this.description = this.$t(this.$g('HOME_DESIGN_YOU_CAN_FIND')[0].description);
    this.image_url = this.$g('HOME_DESIGN_YOU_CAN_FIND')[0].image_url;
    window.addEventListener('scroll', this.scrollEffect);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEffect);
  },
  methods: {
    scrollEffect() {
      const previewImage = this.$refs.ImageYouCanFind;
      if (previewImage?.getBoundingClientRect().top + window.innerHeight / 2 < window.innerHeight) {
        this.$refs.imageToChange.classList.add('native');
      } else {
        this.$refs.imageToChange.classList.remove('native');
      }
    },
    updateContent(description, image_url) {
      this.description = description;
      this.image_url = image_url;
    },
    urlLink(url, translateUrl, landingUrl) {
      return landingUrl
        ? this.$urlBuilder('landing', { uid: url })
        : translateUrl
        ? this.$trailingSlash(this.localePath(url))
        : url;
    }
  }
};
</script>
<style lang="scss" scoped>
.items-list {
  width: calc(25% - 10px);
  padding: 0 10px;
  padding-left: 23px;
  .items-title {
    color: #818181;
  }
  .can-find-item .item-text {
    font-weight: 400;
    font-size: 22px;
    color: $gray;
  }
}
.item-description {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  background-color: #000000;
  padding: 0 20px;
  width: calc(20% - 40px);
  height: calc(60vw * 0.5714);
  .description {
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 400;
  }
}
.image-container {
  flex: 1;
  display: flex;
  width: 55%;
  height: calc(60vw * 0.5714);
  object-fit: contain;
  img {
    width: 100%;
    height: 100%;
  }
  @include lg {
    flex: auto;
  }
}
ul {
  list-style: none;
  @include lg {
    margin-bottom: 5px;
  }
}
li {
  transition: all 0.5s;
  &::after {
    content: '';
    width: 0vw;
    display: block;
    height: 3px;
    background-color: $defaultColor;
    z-index: 1;
    position: absolute;
    transition: all 0.5s;
  }
  &:hover::after {
    transition: all 0.5s;
    width: 100%;
  }
  a {
    padding: 10px 0;
    color: #000000;
    &:hover {
      color: $defaultColor;
      transition: all 0.5s;
    }
  }
}
.can-find {
  height: auto;
}
@media screen and (max-width: $screen-xl-max) {
  .can-find {
    height: 500px;
  }
  .items-list {
    .items-title {
      font-size: 1.5rem;
    }
  }
}

@media screen and (min-width: $screen-lg-min) and (max-width: $screen-xl-max) {
  .items-list {
    width: calc(20vw - 10px);
    .items-title {
      font-size: 1.4rem;
    }
    .can-find-item .item-text {
      font-size: 20px;
    }
  }
  .item-description {
    width: calc(25vw - 40px);
    height: calc(60vw * 0.5714);
  }
}
@media screen and (max-width: $screen-lg-max) {
  .item-description,
  .image-container,
  .items-list {
    width: 100%;
  }
  .item-description {
    height: 130px;
    .description {
      margin: 0;
    }
  }
  .can-find {
    height: auto;
  }
  .image-container {
    height: auto;
  }
  .items-list {
    padding: 10px;
    padding-left: 23px;
  }
}
@media screen and (max-width: $screen-sm-max) {
  .item-description {
    height: 160px;
  }
}
@media screen and (max-width: $screen-xs-max) {
  .item-description {
    height: 240px;
  }
}
@media screen and (min-width: $screen-lg-min) {
  .image-container {
    z-index: 2;
    img {
      transform: translate(-20.4vw, 12.5vh) scale(1.8);
      transition: all 1s;
      &.native {
        transform: translate(0, 0) scale(1);
        transition: all 1s;
      }
    }
  }
  li::before {
    content: '';
    width: 10px;
    height: 10px;
    display: block;
    border-radius: 15px;
    border: 1.5px solid $defaultColor;
    position: absolute;
    left: 0vw;
    z-index: 1;
    bottom: -6px;
    transition: all 0.5s;
    opacity: 0;
  }
  li:hover {
    &::before {
      opacity: 1;
      left: 16.5vw;
      transition: all 0.5s;
    }
    &::after {
      width: 16.5vw;
    }
  }
}
@media screen and (min-width: 1500px) {
  .items-list {
    padding: 0 50px 0 150px;
  }
}
</style>
